import { formatDateInTimezone } from '@/utilities/addFormattedDateFields';

export const CALENDAR_DATE_FORMAT = 'EEE, MMM dd, yyyy';

// Scheduled/estimated dates are calendar days, often stored as UTC midnight or date-only strings.
// formatDateInTimezone pins them to the order's timezone so they don't render as the previous day in US zones.
export const formatCalendarDate = (date, tz) => formatDateInTimezone(date, tz, CALENDAR_DATE_FORMAT);

// Receiving and forward-stocked orders have no meaningful pickup date, so only the delivery date is shown.
export const scheduledDatesLabel = ({ pickupDate, deliveryDate, tz, isReceived, hidePickup, isCrossdocked }) => {
    const parts = [];
    if (!isReceived && !hidePickup) {
        parts.push(`Pickup: ${pickupDate ? formatCalendarDate(pickupDate, tz) : 'Pending'}`);
    }
    parts.push(`${isCrossdocked ? 'Cross-dock' : 'Delivery'}: ${formatCalendarDate(deliveryDate, tz)}`);

    return parts.join(', ');
};

// Where each middle mile step's time comes from, best first: the integration's stamp for that status, then what
// the step's Edit button saved on the event entering the state, then the event that opened the middle mile leg.
const MIDDLE_MILE_TIME_SOURCES = {
    booked: { metaKey: 'pending_time' },
    scheduled: {
        metaKey: 'scheduled_time',
        next: 'MM_CD_PENDING',
        eventFields: ['mm_est_ship_date', 'mm_scheduled_ship_date'],
        beforeField: 'est_ship_date',
    },
    inTransit: {
        metaKey: 'in_transit_time',
        next: 'MM_CD_IN_TRANSIT',
        eventFields: ['mm_ship_date'],
        beforeField: 'ship_date',
    },
    arrived: {
        metaKey: 'arrived_time',
        next: 'MM_CD_ARRIVED',
        eventFields: ['arrived_date'],
        beforeField: 'delivery_date',
    },
};

export const middleMileStepTimes = (order, before) => {
    const events = order?.wh_events || [];

    return Object.fromEntries(
        Object.entries(MIDDLE_MILE_TIME_SOURCES).map(([step, { metaKey, next, eventFields = [], beforeField }]) => {
            const edited = next ? [...events].reverse().find((event) => event.transition?.next === next) : null;
            const time =
                order?.middle_mile_integration_meta?.[metaKey] ||
                eventFields.map((field) => edited?.[field]).find(Boolean) ||
                before?.[beforeField] ||
                null;
            return [step, time];
        })
    );
};
